import dispInfo from "./dispInfo.component";

const dispInfoModule = angular
  .module("app.components.dispInfo", [])
  .component("dispInfo", dispInfo);

export default dispInfoModule;



// WEBPACK FOOTER //
// ./src/components/dispInfo/dispInfo.module.js